import { main } from "./Main";
main();
